import * as yup from 'yup';

export const schema = yup.object({
  des_definicao: yup.string().required(),
  des_condicao: yup.string().required(),
});
